import { WifiOffIcon } from "lucide-react"

/*
 * The slim banner atop the page while the network is gone: what the page already shows stays, and
 * Beacon carries on by itself once the network is back. The shell renders it while the browser is
 * offline (`installed-app/connection.tsx`), on the desk and the compact layout alike.
 */

export function OfflineBanner() {
  return (
    <div
      role="status"
      className="flex shrink-0 items-center justify-center gap-2 border-b border-border-subtle bg-muted px-4 py-1.5 text-xs text-muted-foreground"
    >
      <WifiOffIcon aria-hidden className="size-3.5 shrink-0" />
      You&apos;re offline. Beacon will carry on when you&apos;re back.
    </div>
  )
}
